<template>
  <div class="variantItem">
    <h2>{{ data.name }}</h2>
    <VariantLabel :datas="data.values" :pid="data.code" :pName="data.name" />
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import VariantLabel from '@/components/shop/VariantLabel.vue'

export default {
  name: 'variantItem',
  emits: ['change'],
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  components: { VariantLabel },
  setup(props) {
    let { data } = toRefs(props)
    const state = reactive({ data })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.variantItem {
  margin-bottom: 12px;
  h2 {
    font-size: 16px;
    font-weight: 500;
  }
}
</style>
